import { observer } from 'mobx-react';
import CashbackInfo from '../../components/CashbackInfo/CashbackInfo';
import ProductPrice from '../../components/ProductPrice/ProductPrice';
import ProductSubmit from '../../components/ProductSubmit/ProductSubmit';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import ProductSizes from '../ProductSizes/ProductSizes';
import { WINDOW_SIZES } from 'src/constants/main';
import Quantity from 'src/view/components/Controls/Quantity/Quantity';
import QuantitySkeleton from 'src/view/components/Controls/Quantity/QuantitySkeleton';
import ResponsiveContent from 'src/view/components/ResponsiveContent/ResponsiveContent';
import { appStore } from '~/mobx/appStore';
import './style.scss';
import { PRODUCT_TYPES_WITH_CASHBACK } from '~/constants/products';

const ProductSubmitBlock: React.FC = observer((): JSX.Element => {
  const { branch, product } = orderProductModalStore;
  const isCashbackInfoVisible =
    appStore.isAddonsAvailable.cashback && branch?.is_cashback && product?.type !== undefined && PRODUCT_TYPES_WITH_CASHBACK.includes(product?.type);

  return (
    <div className="product-submit-block p-6">
      <div className="d-flex flex-row align-items-center justify-content-between mb-3">
        <ResponsiveContent min={WINDOW_SIZES.md}>
          <ProductPrice />
        </ResponsiveContent>
      </div>

      <ProductSizes />

      {isCashbackInfoVisible ? <CashbackInfo /> : null}

      <div className="d-flex flex-row align-items-center gap-10">
        {orderProductModalStore.product ? (
          <Quantity
            decreaseId="product_quantity_decrease"
            increaseId="product_quantity_increase"
            value={orderProductModalStore.product.quantity}
            onChange={orderProductModalStore.onChangeQuantity}
            minimum={orderProductModalStore.product.min_quantity}
          />
        ) : (
          <QuantitySkeleton />
        )}

        <ProductSubmit />
      </div>
    </div>
  );
});

export default ProductSubmitBlock;
